/*
this.m_shippingTypes = {                            // this method is set from PHP or by user
    UPS:        this.SHIP_METHOD_US,                // offset 0
    USPS:       this.SHIP_METHOD_ALL,               // offset 1
    FedEx:      this.SHIP_METHOD_INTERNATIONAL,     // ...
    DHL:        this.SHIP_METHOD_INTERNATIONAL,
    PostalEx:   this.SHIP_METHOD_ALL
};
*/

import {MS_15} from "./global-constants";

const TAX_RATE = 9.750;
const SKIP_SHIP_COST_PRODUCTS = ['1070', '1071', '1087', '1088', '1114', '1115', '1035'];
const SHIPPING_TABLE = {UPS: {0: 15, 100: 15, 200: 15, 300: 30, 400: 40}, USPS: {0: 35, 101: 35, 102: 30, 301: 30}};

const isCartOnlyCustomItem = (cartContent) => {
    return cartContent.length === 1 && cartContent[0].product_id == MS_15;
};

export const calcTotals = (cartContent, selectedShipBy, selectedShipTo, chargeMode) => {
    const shippingTotal = chargeMode ? 0 : calcShippingTotal(cartContent, selectedShipBy);
    const subTotal = calcSubTotal(cartContent);
    const taxTotal = chargeMode ? 0 : calcTax(cartContent, subTotal, selectedShipTo);
    const orderTotal = shippingTotal + subTotal + taxTotal;
    return {
        shippingTotal: shippingTotal.toFixed(2),
        subTotal: subTotal.toFixed(2),
        taxTotal: taxTotal.toFixed(2),
        orderTotal: orderTotal.toFixed(2)
    };
};

export const calcShippingTotal = (cartContent, selectedShipBy) => {
    if (cartContent.length === 0) return 0;
    if (isCartOnlyCustomItem(cartContent)) return 0;
    const points = calcShippingPoints(cartContent);
    if (points === 0) return 0;
    let totalShipping = 0;
    for (const cartLocation in SHIPPING_TABLE) {
        if (cartLocation === selectedShipBy) {
            for (const shipRange in SHIPPING_TABLE[cartLocation]) {
                if (points >= Number(shipRange)) {
                    totalShipping += Number(SHIPPING_TABLE[cartLocation][shipRange]);
                }
            }
        }
    }
    return totalShipping;
};

export const calcShippingPoints = (cartContent) => {
    let totalPoints = 0;
    cartContent.forEach((cartProduct) => {
        if (SKIP_SHIP_COST_PRODUCTS.indexOf(String(cartProduct.product_id)) > -1) return;
        totalPoints += (cartProduct.shipping_points * cartProduct.product_count);
        totalPoints += cartProduct.shipping_points;
    });
    return totalPoints;
};

export const calcTax = (cartContent, subTotal, selectedShipTo) => {
    if (!selectedShipTo) return 0;
    if (selectedShipTo.indexOf('CA') === -1) return 0;
    if (isCartOnlyCustomItem(cartContent)) return 0;
    return subTotal * ((TAX_RATE) / 100);
};

export const calcSubTotal = (cartContent) => {
    let subtotal = 0;
    cartContent.forEach((cartProduct) => {
        subtotal += cartProduct.product_price * cartProduct.product_count;
    });
    return subtotal;
};
